/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Visibility_HiddenInputs */

const en_style_guide_manager_visibility_hidden = /** @type {(inputs: Style_Guide_Manager_Visibility_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden`)
};

const fr_style_guide_manager_visibility_hidden = /** @type {(inputs: Style_Guide_Manager_Visibility_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masque`)
};

const de_style_guide_manager_visibility_hidden = /** @type {(inputs: Style_Guide_Manager_Visibility_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versteckt`)
};

const it_style_guide_manager_visibility_hidden = /** @type {(inputs: Style_Guide_Manager_Visibility_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nascosto`)
};

const ru_style_guide_manager_visibility_hidden = /** @type {(inputs: Style_Guide_Manager_Visibility_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрытый`)
};

const es_style_guide_manager_visibility_hidden = /** @type {(inputs: Style_Guide_Manager_Visibility_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oculto`)
};

const zh_cn2_style_guide_manager_visibility_hidden = /** @type {(inputs: Style_Guide_Manager_Visibility_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐`)
};

const ja_style_guide_manager_visibility_hidden = /** @type {(inputs: Style_Guide_Manager_Visibility_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隠れた`)
};

const hi_style_guide_manager_visibility_hidden = /** @type {(inputs: Style_Guide_Manager_Visibility_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छिपा हुआ`)
};

const pt_pt2_style_guide_manager_visibility_hidden = /** @type {(inputs: Style_Guide_Manager_Visibility_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escondido`)
};

/**
* | output |
* | --- |
* | "Hidden" |
*
* @param {Style_Guide_Manager_Visibility_HiddenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_visibility_hidden = /** @type {((inputs?: Style_Guide_Manager_Visibility_HiddenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Visibility_HiddenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_visibility_hidden(inputs)
	if (locale === "de") return de_style_guide_manager_visibility_hidden(inputs)
	if (locale === "it") return it_style_guide_manager_visibility_hidden(inputs)
	if (locale === "ru") return ru_style_guide_manager_visibility_hidden(inputs)
	if (locale === "es") return es_style_guide_manager_visibility_hidden(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_visibility_hidden(inputs)
	if (locale === "ja") return ja_style_guide_manager_visibility_hidden(inputs)
	if (locale === "hi") return hi_style_guide_manager_visibility_hidden(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_visibility_hidden(inputs)
	return en_style_guide_manager_visibility_hidden(inputs)
});